import DealerActionTypes from './dealer.types';

/** ***************** ADD DEALER DETAILS START *********************** */
export const addDealerDetailsStart = (addData: any) => ({
	type: DealerActionTypes.ADD_DEALER_DETAILS_START,
	payload: addData,
});

export const addDealerDetailsSuccess = (successData: any) => ({
	type: DealerActionTypes.ADD_DEALER_DETAILS_SUCCESS,
	payload: successData,
});

export const addDealerDetailsFailure = (failureData: any) => ({
	type: DealerActionTypes.ADD_DEALER_DETAILS_FAILURE,
	payload: failureData,
});

export const addDealerDetailsResponseResetStart = () => ({
	type: DealerActionTypes.ADD_DEALER_DETAILS_RESPONSE_RESET,
});

export const addDealerDetailsResponseChanged = () => ({
	type: DealerActionTypes.ADD_DEALER_DETAILS_RESPONSE_CHANGED,
});
/** ***************** ADD DEALER DETAILS END *********************** */

/** ***************** UPDATE DEALER DETAILS START *********************** */
export const updateDealerDetailsStart = (updateData: any) => ({
	type: DealerActionTypes.UPDATE_DEALER_DETAILS_START,
	payload: updateData,
});

export const updateDealerDetailsSuccess = (successData: any) => ({
	type: DealerActionTypes.UPDATE_DEALER_DETAILS_SUCCESS,
	payload: successData,
});

export const updateDealerDetailsFailure = (failureData: any) => ({
	type: DealerActionTypes.UPDATE_DEALER_DETAILS_FAILURE,
	payload: failureData,
});

export const updateDealerDetailsResponseResetStart = () => ({
	type: DealerActionTypes.UPDATE_DEALER_DETAILS_RESPONSE_RESET,
});

export const updateDealerDetailsResponseChanged = () => ({
	type: DealerActionTypes.UPDATE_DEALER_DETAILS_RESPONSE_CHANGED,
});
/** ***************** UPDATE DEALER DETAILS END *********************** */

/** ***************** GET DEALER DETAILS START *********************** */
export const getDealerListStart = (getData: any) => ({
	type: DealerActionTypes.GET_DEALER_LIST_START,
	payload: getData,
});

export const getDealerListSuccess = (successData: any) => ({
	type: DealerActionTypes.GET_DEALER_LIST_SUCCESS,
	payload: successData,
});

export const getDealerListFailure = (failureData: any) => ({
	type: DealerActionTypes.GET_DEALER_LIST_FAILURE,
	payload: failureData,
});

export const getDealerListResponseResetStart = () => ({
	type: DealerActionTypes.GET_DEALER_LIST_RESPONSE_RESET,
});

export const getDealerListResponseChanged = () => ({
	type: DealerActionTypes.GET_DEALER_LIST_RESPONSE_CHANGED,
});
/** ***************** GET DEALER DETAILS END *********************** */

/** ***************** FETCH DEALER DETAILS START *********************** */
export const fetchDealerDetailsStart = (fetchData: any) => ({
	type: DealerActionTypes.FETCH_DEALER_DETAILS_START,
	payload: fetchData,
});

export const fetchDealerDetailsSuccess = (successData: any) => ({
	type: DealerActionTypes.FETCH_DEALER_DETAILS_SUCCESS,
	payload: successData,
});

export const fetchDealerDetailsFailure = (failureData: any) => ({
	type: DealerActionTypes.FETCH_DEALER_DETAILS_FAILURE,
	payload: failureData,
});

export const fetchDealerDetailsResponseResetStart = () => ({
	type: DealerActionTypes.FETCH_DEALER_DETAILS_RESPONSE_RESET,
});

export const fetchDealerDetailsResponseChanged = () => ({
	type: DealerActionTypes.FETCH_DEALER_DETAILS_RESPONSE_CHANGED,
});
/** ***************** FETCH DEALER DETAILS END *********************** */

/** ***************** DELETE DEALER DETAILS START *********************** */
export const deleteDealerDetailsStart = (deleteData: any) => ({
	type: DealerActionTypes.DELETE_DEALER_DETAILS_START,
	payload: deleteData,
});

export const deleteDealerDetailsSuccess = (successData: any) => ({
	type: DealerActionTypes.DELETE_DEALER_DETAILS_SUCCESS,
	payload: successData,
});

export const deleteDealerDetailsFailure = (failureData: any) => ({
	type: DealerActionTypes.DELETE_DEALER_DETAILS_FAILURE,
	payload: failureData,
});

export const deleteDealerDetailsResponseResetStart = () => ({
	type: DealerActionTypes.DELETE_DEALER_DETAILS_RESPONSE_RESET,
});

export const deleteDealerDetailsResponseChanged = () => ({
	type: DealerActionTypes.DELETE_DEALER_DETAILS_RESPONSE_CHANGED,
});

/** ***************** DELETE DEALER DETAILS END *********************** */

/** ***************** DELETE DEALER STAFF DETAILS START *********************** */
export const deleteDealerStaffDetailsStart = (deleteData: any) => ({
	type: DealerActionTypes.DELETE_DEALER_STAFF_DETAILS_START,
	payload: deleteData,
});

export const deleteDealerStaffDetailsSuccess = (successData: any) => ({
	type: DealerActionTypes.DELETE_DEALER_STAFF_DETAILS_SUCCESS,
	payload: successData,
});

export const deleteDealerStaffDetailsFailure = (failureData: any) => ({
	type: DealerActionTypes.DELETE_DEALER_STAFF_DETAILS_FAILURE,
	payload: failureData,
});

export const deleteDealerStaffDetailsResponseResetStart = () => ({
	type: DealerActionTypes.DELETE_DEALER_STAFF_DETAILS_RESPONSE_RESET,
});

export const deleteDealerStaffDetailsResponseChanged = () => ({
	type: DealerActionTypes.DELETE_DEALER_STAFF_DETAILS_RESPONSE_CHANGED,
});
/** ***************** APPROVE DEALER START *********************** */
export const approveDealerDetailsStart = (approveData: any) => ({
	type: DealerActionTypes.APPROVE_DEALER_START,
	payload: approveData,
});

export const approveDealerDetailsSuccess = (successData: any) => ({
	type: DealerActionTypes.APPROVE_DEALER_SUCCESS,
	payload: successData,
});

export const approveDealerDetailsFailure = (failureData: any) => ({
	type: DealerActionTypes.APPROVE_DEALER_FAILURE,
	payload: failureData,
});

export const approveDealerDetailsResponseResetStart = () => ({
	type: DealerActionTypes.APPROVE_DEALER_RESPONSE_RESET,
});

export const approveDealerDetailsResponseChanged = () => ({
	type: DealerActionTypes.APPROVE_DEALER_RESPONSE_CHANGED,
});
/** ***************** APPROVE DEALER END *********************** */

/** ***************** DELETE DEALER STAFF DETAILS END *********************** */
